module.exports = __webpack_public_path__ + "img/close_focused_prelight.68f5d2aa.png";